// List of Esri map marker layer Id's.
export const SKETCH_GRAPHICS_LAYER = 'Sketch Graphics Layer';
export const W3W_MARKER_LAYER = 'w3w-marker-layer';
export const ALERT_MARKER_CIRCLES_LAYER = 'alert-marker-circles-layer';
export const ALERT_MARKERS_LAYER = 'alert-markers-layer';
export const AA_ALERT_MARKER_CIRCLES_LAYER = 'aa-alert-marker-circles-layer';
export const AA_ALERT_MARKERS_LAYER = 'aa-alert-markers-layer';
export const TRAIN_ALERT_MARKER_CIRCLES_LAYER =
  'train-alert-marker-circles-layer';
export const TRAIN_ALERT_MARKERS_LAYER = 'train-alert-markers-layer';
export const TEST_ALERT_MARKER_CIRCLES_LAYER =
  'test-alert-marker-circles-layer';
export const TEST_ALERT_MARKERS_LAYER = 'test-alert-markers-layer';
export const CALL_MARKERS_POLYLINE_LAYER = 'call-markers-polyline-layer';
export const CALL_MARKER_CIRCLES_LAYER = 'call-marker-circles-layer';
export const CALL_MARKERS_LAYER = 'call-markers-layer';
